import {ApigetServerTime} from '@api/service'
export default {
    namespaced: true,
    state: {
        serviceTime:0,
        //服务器时间计时器
        serviceTimer:null
    },
    mutations: {
        setServiceTime (state,date) {
            state.serviceTime = date
        },
        clearServiceTimer(state){
            console.log('清除服务器时间计时器')
            clearInterval(state.serviceTimer)
            state.serviceTimer = null;
        }
    },
    actions:{
        getServiceTime({commit,dispatch,state},isClear = true){
            return new Promise((resolve,reject)=>{
                ApigetServerTime().then(res=>{
                    if(res.code == '12200'){
                    
                        let TimezoneOffset = new Date().getTimezoneOffset() - -480;
                        let LocalTime = res.data + (TimezoneOffset*60*1000)

                        commit('setServiceTime',LocalTime)
                        
                        if(isClear){
                            clearInterval(state.serviceTimer)
                            state.serviceTimer = setInterval(() => {
                                commit('setServiceTime',state.serviceTime += 1000)
                            }, 1000);
                        }
                        
                        resolve(res)
                    }
                    reject(res)
                })
            })
        },
    },
    getters:{
        getServiceTime(state){
            if(state.serviceTimer == null){
                return 0;
            }else{
                return state.serviceTime
            }
        }
    }
}